import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const YoutubeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "YoutubeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.6261 18.9416C18.1611 18.9922 17.685 19.001 17.2287 18.9999C13.6694 18.9966 10.1101 18.9933 6.55182 18.9911C5.43192 18.9911 4.21221 18.9548 3.34678 18.2402C2.37167 17.4331 2.16875 16.0337 2.08977 14.7675C1.98009 13.0322 1.97131 11.2914 2.06125 9.55506C2.11061 8.60155 2.19726 7.62491 2.60639 6.76169C2.90036 6.14179 3.39065 5.58466 4.01806 5.29178C4.74748 4.95155 5.5109 5.01211 6.29626 5.01101C8.17629 5.00881 10.0563 5.00771 11.9364 5.00551C13.891 5.0033 15.8467 5.0022 17.8013 5C18.7249 5 19.7164 5.01872 20.47 5.55493C21.4429 6.24639 21.7072 7.56215 21.829 8.7524C22.0539 10.9446 22.0571 13.1599 21.8378 15.3521C21.7467 16.2561 21.5954 17.2118 21.002 17.8978C20.414 18.5782 19.542 18.8403 18.6272 18.9405L18.6261 18.9416Z"
        fill="#FF0209"
      />
      <path d="M15 11.9999L10 8.99988V14.9999L15 11.9999Z" fill="white" />
    </svg>
  );
};

export default YoutubeIcon;
